import { CandidateStatusDto, CompanySizeDto } from '@/api/generated';
import {
  CandidateDetailsTranslation,
  CandidateStatusesTranslation,
} from '@/assets/locales/views/candidates/details/candidateDetails.translation.en.ts';
import { quickTipsTranslation } from '@/assets/locales/views/candidates/details/quickTips/quickTips.translation.pl.ts';
import { CandidateTabsModel } from '@/views/candidates/details/model/CandidateTabs.model.ts';

export const candidateStatusesTranslation: CandidateStatusesTranslation = {
  [CandidateStatusDto.AwaitingDownload]: 'Oczekuje na przygotowanie CV',
  [CandidateStatusDto.AwaitingExternalPick]: 'Oczekuje na eRecruiter',
  [CandidateStatusDto.AwaitingProcessing]: 'Oczekuje na przetworzenie',
  [CandidateStatusDto.CheckExternalProcess]: 'Sprawdź eRecruiter',
  [CandidateStatusDto.Downloading]: 'Przygotowywanie CV',
  [CandidateStatusDto.Error]: 'Błąd',
  [CandidateStatusDto.Imported]: 'Zaimportowany',
  [CandidateStatusDto.InProgress]: 'W toku',
  [CandidateStatusDto.InsufficientPositionDescription]: 'Niepełny opis stanowiska',
  [CandidateStatusDto.New]: 'Nowy',
  [CandidateStatusDto.NoFileFound]: 'Brak pliku',
  [CandidateStatusDto.ProcessingOutdated]: 'Ocena nieaktualna',
  [CandidateStatusDto.ProcessNotReady]: 'Profil gotowy, analiza nieuruchomiona',
  [CandidateStatusDto.Seen]: 'Dostępny',
  [CandidateStatusDto.UnrelatedExperience]: 'Niepasujące doświadczenie',
  sent: 'Wysłany do eRecruitera',
};

export const candidateDetailsTranslation: CandidateDetailsTranslation = {
  about: 'O kandydacie',
  analysisRemarks: {
    buttons: {
      list: 'Zobacz uwagi do analizy',
      submitRemark: 'Zgłoś uwagę',
    },
    dialog: {
      buttons: {
        cancel: 'Anuluj',
        submit: 'Wyślij uwagi',
      },
      field: 'Twoje uwagi',
      instruction:
        'Opisz konkretnie, z czym się nie zgadzasz w analizie. Zamiast ogólnych komentarzy typu "powinien mieć wyższą ocenę", wyjaśnij które umiejętności, doświadczenie lub kwalifikacje zostały nieprawidłowo ocenione i dlaczego.',
      placeholder: 'Opisz co jest niepoprawne w analizie i dlaczego...',
      title: 'Uwagi do analizy',
    },
    list: {
      close: 'Zamknij',
      noResults: 'Brak zgłoszonych uwag dla tego kandydata.',
      title: 'Uwagi do analizy',
    },
  },
  companySize: {
    [CompanySizeDto.Big]: 'Duża (250-999)',
    [CompanySizeDto.Enterprise]: 'Korporacja (1000+)',
    [CompanySizeDto.Medium]: 'Średnia (100-249)',
    [CompanySizeDto.Micro]: 'Mikro (1-9)',
    [CompanySizeDto.Small]: 'Mała (10-99)',
  },
  copyId: 'Skopiuj ID',
  copyIdSuccess: 'Skopiowano do schowka',
  currentEmployer: 'Obecny pracodawca',
  currentPosition: 'Obecne stanowisko',
  deleteCandidate: {
    button: 'Usuń kandydata',
    dialog: {
      content:
        'Czy na pewno chcesz usunąć tego kandydata? Wszystkie dane kandydata zostaną trwale usunięte. Tej operacji nie można cofnąć.',
    },
  },
  downloadCv: 'Pobierz CV',
  employer: {
    noData: 'Brak danych',
    products: 'Produkty',
    services: 'Usługi',
  },
  eRecruiterId: 'Identyfikator eRecruiter',
  feedback: 'Odpowiedź zwrotna',
  interviewSimulation: {
    buttons: {
      history: 'Symulacja Rozmowy Rekrutacyjnej',
    },
  },
  knowMeId: 'Identyfikator',
  lastEmployer: 'Ostatni pracodawca',
  match: 'Poziom dopasowanie',
  notLinked: 'niepołączony z eRecruiter',
  pick: {
    button: 'Wybierz kandydata',
    dialog: {
      content: 'Czy na pewno chcesz wybrać tego kandydata? Proszę potwierdzić, aby kontynuować.',
    },
    notExternalCandidate: 'Kandydat z PDF',
    selected: 'Ten kandydat został wybrany',
  },
  quickTips: quickTipsTranslation,
  quickView: {
    title: 'Szybki podgląd analizy',
  },
  rates: {
    1: '1 gwiazdka: Niedopasowanie',
    2: '2 gwiazdki: Słabe dopasowanie',
    3: '3 gwiazdki: Zadowalające dopasowanie ',
    4: '4 gwiazki: Dobre dopasowanie',
    5: '5 gwiazdek: Idealne dopasowanie',
    rating: 'Ocena',
  },
  redFlags: 'Zagrożenia',
  refreshAnalysis: {
    button: 'Ponów Analizę',
    dialog: {
      content:
        'Czy na pewno chcesz ponownie przeanalizować tego kandydata? Proszę potwierdzić, aby kontynuować.',
    },
  },
  statuses: candidateStatusesTranslation,
  strengths: 'Mocne strony',
  tabs: {
    [CandidateTabsModel.CANDIDATE_SUMMARY]: 'Podsumowanie kandydata',
    [CandidateTabsModel.MATCHING_RESULT]: 'Wynik analizy dopasowania',
  },
  tour: {
    analysisRemarksList: {
      text: 'Ten przycisk pozwala przeglądać komentarze dodane wcześniej do analizy kandydata.',
      title: 'Komentarze do analizy',
    },
    analysisRemarksSubmit: {
      text: 'Ten przycisk pozwala dodać komentarz do analizy kandydata. Komentarze będą uwzględniane przy pracy nad rozwojem aplikacji i kolejnych analiz.',
      title: 'Dodaj komentarz do analizy',
    },
    matchComponents: {
      text: 'Dla procesów B2C ta sekcja pokazuje składowe oceny kandydata, w tym główną analizę i dodatkowe czynniki punktacji.',
      title: 'Składowe oceny',
    },
    tags: {
      text: 'Tutaj wyświetlane są tagi przypisane do kandydata.',
      title: 'Tagi kandydata',
    },
  },
  weaknesses: 'Słabe strony',
};
